<p>admanager works!</p>
